import(/* webpackMode: "eager" */ "/opt/render/project/src/src/app/activeParcels/page.js");
